// 评分组件
<template>
  <div class="set-rate-container">
    <ul class="stars" @mouseleave="handleMouseLeave">
      <li
        v-for="i in 5"
        :key="i"
        :class="i <= hoverScore ? 'hover-score' : ''"
        @click="handleComment(i)"
        @mouseenter="handleMouseEnter(i)"
      >
        <img
          v-if="disable ? i <= integer : hoverScore > integer && i <= integer"
          src="../imgs/star-fill.png"
          alt=""
        />
        <img
          v-else-if="decimal > 0 && i === integer + 1"
          src="../imgs/star-half.png"
          alt=""
        />
        <img v-else src="../imgs/star.png" alt="" />
      </li>
    </ul>
    <span v-if="showValue" class="score">{{ score }}</span>
  </div>
</template>

<script>
export default {
  props: {
    // 默认值
    value: {
      type: Number,
      default: 0
    },
    // 是否禁用
    disable: {
      type: Boolean,
      default: false
    },
    // 是否显示数值
    showValue: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 评分
      score: 0,
      // 鼠标移入显示的评分
      hoverScore: 0
    }
  },
  computed: {
    // 整数
    integer() {
      return this.score > 0 ? parseInt(this.score) : this.score >= 5 ? 5 : 0
    },
    // 小数
    decimal() {
      return this.score > 0
        ? String(this.score).indexOf('.') + 1 > 0
          ? 1
          : 0
        : 0
    },
    // 默认值
    defaultValue() {
      return 5 - this.integer - this.decimal
    }
  },
  watch: {
    value() {
      this.score = this.value
      this.hoverScore = this.value
    }
  },
  created() {
    this.score = this.value
  },
  methods: {
    // 点击选择评分
    handleComment(i) {
      if (!this.disable) {
        this.score = i
        this.$emit('setScore', this.score)
      } else {
        return
      }
    },
    // 鼠标移入选择
    handleMouseEnter(i) {
      if (!this.disable) {
        this.hoverScore = i
      } else {
        return
      }
    },
    // 鼠标移出
    handleMouseLeave() {
      if (!this.disable) {
        this.hoverScore = this.score
      } else {
        return
      }
    }
  }
}
</script>

<style lang="scss">
.set-rate-container {
  display: flex;
  align-items: center;
  .stars {
    display: flex;
    align-items: center;
    li {
      margin-right: 3px;
      width: 14px;
      height: 14px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .hover-score {
      background-size: 100%;
      background-image: url('../../../assets/images/homePage/star-fill.png');
    }
  }
  .score {
    font-size: 14px;
    color: #f6c146;
    margin-left: 10px;
  }
}
</style>
